import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1305b9ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1305b9ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305b9ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1305b9ca')) {
      api.createRecord('1305b9ca', component.options)
    } else {
      api.reload('1305b9ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1305b9ca&scoped=true", function () {
      api.rerender('1305b9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TinymceForApp/index.vue"
export default component.exports